<template>
  <Container>
    <HeroCard
      :heading="t('jc.view.dungeon.hero.title')"
      :paragraph="t('jc.view.dungeon.hero.text')"
      :image="{
        src: 'images/view/game/dungeon-explorer/hero_banner.png',
        alt: t('jc.view.dungeon.hero.banner.alt'),
      }"
      :label="t('jc.view.dungeon.hero.button.label')"
      :icon="'play'"
      :float="{
        src: 'images/skin_renders/compositions/triumphant_sword.png',
      }"
      :to="config.public.youtubeDungeonExplorerTrailerUrl"
      :buttons="[
        {
          label: t('jc.view.dungeon.hero.guide.label'),
          to: localePath({ name: 'game-dungeon-explorer-guide' }),
        },
        {
          label: t('jc.view.dungeon.hero.leaderboard.label'),
          to: localePath({ name: 'game-dungeon-explorer-leaderboard' }),
        },
      ]"
    />
  </Container>

  <Container>
    <FeatureTree
      :title="t('jc.view.dungeon.featureTree.title')"
      :items="featureItems"
      alternating
    />
  </Container>

  <!-- ingame footage component -->

  <Container>
    <JoinCard
      :server="t('jc.view.dungeon.hero.title')"
      :image="{ src: 'images/view/game/dungeon-explorer/call_to_action_background.png' }"
    />
  </Container>
</template>

<script setup lang="ts">
const { t } = useI18n()
const config = useRuntimeConfig()
const localePath = useLocalePath()

definePageMeta({
  nameKey: 'game-dungeon',
  head: {
    imageUrl: '/images/view/game/dungeon-explorer/meta_preview.png',
  },
})

const featureItems = [
  {
    icon: 'flag',
    content: {
      title: t('jc.view.dungeon.featureTree.found.title'),
      text: t('jc.view.dungeon.featureTree.found.text'),
      image: {
        src: 'images/skin_renders/compositions/enter_dungeon.png',
      },
    },
  },
  {
    icon: 'sack',
    content: {
      title: t('jc.view.dungeon.featureTree.gather.title'),
      text: t('jc.view.dungeon.featureTree.gather.text'),
      image: {
        src: 'images/skin_renders/compositions/fight_mob.png',
      },
    },
  },
  {
    icon: 'fort',
    content: {
      title: t('jc.view.dungeon.featureTree.build.title'),
      text: t('jc.view.dungeon.featureTree.build.text'),
      image: {
        src: 'images/skin_renders/compositions/combine_buffs.png',
      },
    },
  },
  {
    icon: 'swords',
    content: {
      title: t('jc.view.dungeon.featureTree.fight.title'),
      text: t('jc.view.dungeon.featureTree.fight.text'),
      image: {
        src: 'images/skin_renders/compositions/gather_loot.png',
      },
    },
  },
  {
    icon: 'sparkles',
    content: {
      title: t('jc.view.dungeon.featureTree.upgrade.title'),
      text: t('jc.view.dungeon.featureTree.upgrade.text'),
      image: {
        src: 'images/skin_renders/compositions/upgrade_gear.png',
      },
    },
  },
  {
    icon: 'trophy',
    content: {
      title: t('jc.view.dungeon.featureTree.climb.title'),
      text: t('jc.view.dungeon.featureTree.climb.text'),
      image: {
        src: 'images/skin_renders/compositions/rank_up.png',
      },
    },
  },
  // more tree-levels
]
</script>
